import { Calendar, Clock3, FileSliders, Phone } from "lucide-react";

import SidebarItem from "./SidebarItem";
import { formatLeadFieldValue, groupLeadFields } from "../../utils/leadFields";

function formatDate(value) {
    if (!value) return "-";

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;

    return date.toLocaleDateString(undefined, {
        day: "numeric",
        month: "short",
        year: "numeric",
    });
}

function InfoCard({ icon: Icon, iconClassName, title, description, children }) {
    return (
        <section className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm sm:p-6">
            <div className="mb-6 flex items-center gap-3">
                <div className={`flex h-10 w-10 items-center justify-center rounded-xl ${iconClassName}`}>
                    <Icon className="h-5 w-5" />
                </div>
                <div>
                    <h3 className="font-semibold text-slate-900">{title}</h3>
                    <p className="text-sm text-slate-500">{description}</p>
                </div>
            </div>
            <div className="space-y-4">{children}</div>
        </section>
    );
}

export default function LeadInfoCards({ lead }) {
    const schemaGroups = groupLeadFields(lead.lead_schema || []);
    const customGroups = groupLeadFields(lead.custom_field_values || []);

    return (
        <div className="mt-6 grid grid-cols-1 gap-5 lg:grid-cols-2">
            {Object.entries(schemaGroups).map(([section, fields]) => <InfoCard key={section} icon={FileSliders} iconClassName="bg-sky-50 text-sky-700" title={section} description="Pipeline lead information">
                {fields.map((field) => <SidebarItem key={field.key} icon={<FileSliders size={16} />} label={field.label} value={lead[field.key]} />)}
            </InfoCard>)}

            <InfoCard
                icon={Calendar}
                iconClassName="bg-emerald-50 text-emerald-600"
                title="Timeline"
                description="Important lead activity dates"
            >
                <SidebarItem icon={<Calendar size={16} />} label="Created" value={formatDate(lead.created_at)} />
                <SidebarItem icon={<Clock3 size={16} />} label="Updated" value={formatDate(lead.updated_at)} />
                <SidebarItem icon={<Phone size={16} />} label="Last contact" value={formatDate(lead.last_contacted_at)} />
            </InfoCard>

            {Object.entries(customGroups).map(([section, fields]) => (
                <InfoCard
                    key={section}
                    icon={FileSliders}
                    iconClassName="bg-sky-50 text-sky-700"
                    title={section}
                    description="Workspace-specific lead information"
                >
                    {fields.map((field) => (
                        <SidebarItem
                            key={field.field_id}
                            icon={<FileSliders size={16} />}
                            label={field.label}
                            value={formatLeadFieldValue(field, field.value, field.user)}
                        />
                    ))}
                </InfoCard>
            ))}
        </div>
    );
}
